import { Component, Injector, Input, OnInit, Signal, ViewEncapsulation } from '@angular/core';
import { UserService } from '@fi-app/user/user.service';
import { UnitColleagueParameterModel } from './unit-colleague-parameter-model';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiRemoteStateFullDataSource } from '@fi-shared/fi-items-list/fi-remote-state-full-data-source';
import { ILoadDataArgs } from '@fi-shared/fi-items-list/fi-data-source-base.directive';
import { IFiHttpPromise } from '@fi-shared/to-fi-promise';
import { IItemsListDataFetchResult } from '@fi-shared/fi-items-list/fi-items-list';
import { ObjectTypes } from '@fi-shared/types';
import { FiUserSharedService } from '@fi-shared/fi-user-shared/fi-user-shared.service';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';
import { IUnitColleagueModel } from '@fi-app/components/colleagues-list/colleagues-list';

@Component({
    selector: 'fi-colleagues-list',
    template: `
        <fi-wrapper-table
            matSort
            [matSortDisableClear]="false"
            [matSortActive]="sortColumn"
            [matSortDirection]="getMatSortDirection()"
            (matSortChange)="onSortChanged($event)"
            [items]="items()"
            [hasCheckedColumn]="false"
            [loading]="loading()"
            (fiWhenScrolled)="onScrollToBottom()"
            [fiWhenScrolledListDisplayedItems]="items().length"
        >
            <ng-container matColumnDef="FullName">
                <mat-header-cell *matHeaderCellDef mat-sort-header #headerCell>
                    <fi-wrapper-table-custom-sort-icon
                        sortIconType="string"
                        [ariaSortAttribute]="headerCell._getAriaSortAttribute()"
                        [headerLabel]="'common.name'"
                    >
                    </fi-wrapper-table-custom-sort-icon>
                </mat-header-cell>
                <mat-cell *matCellDef="let item">
                    <fi-wrapper-table-span-cell
                        class="BrandedColorHover cursor-pointer"
                        (click)="openUserViewDialog($event, item.Id)"
                        [value]="item.FullName"
                    >
                    </fi-wrapper-table-span-cell>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="LatestActivity">
                <mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    [hidden]="isLatestActivityColumnHidden()"
                    #headerCell
                >
                    <fi-wrapper-table-custom-sort-icon
                        sortIconType="number"
                        [ariaSortAttribute]="headerCell._getAriaSortAttribute()"
                        [headerLabel]="'user.last_seen'"
                    >
                    </fi-wrapper-table-custom-sort-icon>
                </mat-header-cell>
                <mat-cell [hidden]="isLatestActivityColumnHidden()" *matCellDef="let item">
                    <fi-wrapper-table-span-cell [value]="getUserLatestActivity(item)"></fi-wrapper-table-span-cell>
                </mat-cell>
            </ng-container>
        </fi-wrapper-table>
    `,
    styleUrls: ['./colleagues-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-colleagues-list' },
    standalone: false,
})
export class ColleaguesListComponent extends FiRemoteStateFullDataSource<IUnitColleagueModel> implements OnInit {
    @Input() unitId: number;

    defaultSortColumnName: string = 'FullName';
    defaultSortDirection: boolean = false;
    objectType: ObjectTypes = ObjectTypes.User;
    extendedSearchMode = true;
    itemsListType = FiItemsListType.UnitColleagues;
    FiStateNames = FiStateNames;
    protected isLatestActivityColumnHidden: Signal<boolean>;

    constructor(
        private userService: UserService,
        private userSharedService: FiUserSharedService,
        injector: Injector,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.isLatestActivityColumnHidden = this.userSharedService.getLatestActivityColumnHiddenSignal(this.items);
    }

    getUserLatestActivity(user: IUnitColleagueModel): string {
        return this.userSharedService.getLatestActivity(user.LatestActivity, user.HasEditAccess);
    }

    openUserViewDialog($event: MouseEvent, userId: number) {
        $event.stopPropagation();
        this.userService.openUserViewDialog(userId);
    }

    loadListDataFn(loadArgs: ILoadDataArgs): IFiHttpPromise<IItemsListDataFetchResult<IUnitColleagueModel>> {
        let parameter: UnitColleagueParameterModel = new UnitColleagueParameterModel();
        parameter = Object.assign(parameter, this.getItemsListParameter(loadArgs));
        parameter.UnitId = this.unitId;

        parameter.FetchParams = {
            FetchItems: true,
            FetchTotalCount: !loadArgs.fetchOnlyItems,
            FetchLightWeightObjects: false,
        };
        return this.userService.getUnitColleaguesListData(parameter);
    }
}
